import Cookies from "js-cookie";

/**
 * Hostnames that serve the Bayut/KSA developer portal but don't carry the
 * usual `bayutsa` marker in their URL. The Bayut build ships with
 * REACT_APP_NODE_ENV != "production", so it falls through to the substring
 * check below — we add explicit matches here so the right tenant config is
 * picked up on these hosts.
 */
const BAYUT_DEVELOPER_HOSTS = new Set(["one.propforce.com", "developer-portal.dubizzlelabs.run"]);

const getAgency = () => {
  if (typeof window !== "undefined") {
    if (process.env.REACT_APP_NODE_ENV === "production") {
      return window.location.host.split(".")[0];
    }
    // Local/dev override: pin the agency explicitly (e.g. REACT_APP_AGENCY=bayut
    // in .env.local) so the portal can be exercised without host/cookie juggling.
    if (process.env.REACT_APP_AGENCY) {
      return process.env.REACT_APP_AGENCY;
    }
    const hostname = window.location.hostname;
    if (hostname.includes("bayutsa") || BAYUT_DEVELOPER_HOSTS.has(hostname)) {
      return "bayut";
    }
  }
  return Cookies.get("tenant") === "KSA" ? "bayut" : "zd";
};

export const AGENCY = getAgency();

/**
 * The Bayut/KSA agency configs. Everything else in `agenciesConfig` is
 * Zameen-flavoured.
 */
const BAYUT_AGENCIES = new Set(["bayut", "training-bayut"]);

/**
 * True on every Zameen environment, live and training alike.
 *
 * `AGENCY` is an *environment* key, not a tenant: on a production build it is the
 * first host segment, so Zameen resolves to `zd` on live but `training` on
 * training.propone.pk. Comparing against `"zd"` therefore silently excludes every
 * non-live Zameen environment — which is how Zameen-only rules ended up disabled on
 * training while working on live.
 *
 * Excluding the Bayut keys rather than listing the Zameen ones is the safer
 * direction: a new Zameen-flavoured environment keeps the rule enforced, and a new
 * Bayut one fails loudly rather than quietly skipping.
 */
export const IS_ZAMEEN_AGENCY = !BAYUT_AGENCIES.has(AGENCY);
